import { TFunction } from '@lichtblick/i18next';
import { GetUsers_V1Query } from '@lichtblick/types';

export const createAssigneeOptions = (
  users: GetUsers_V1Query['getUsers_V1']['data'],
  currentUserId: number,
  t: TFunction,
) => {
  if (!users) {
    return [];
  }

  return [
    { label: t('common:filterUnassigned'), value: 0 },
    ...users.map((user) => {
      if (user.id === currentUserId) {
        return {
          label: t('common:me'),
          value: user.id,
        };
      }

      return {
        label: `${user.firstName} ${user.lastName}`,
        value: user.id,
      };
    }),
  ];
};
